export default __webpack_public_path__ + "static/logo-9d1b3cbb44cd8c4efdcb8f50f6635ec7.svg";